import { cn } from '@playerbase/ui';

// Placeholder for personal account settings. The page lives at
// /s/:studioShortId/account so it stays inside AppShell while we wait for the
// real personal-account surface (display name, email, password, etc.) to
// land. Studio admin moved to /s/:studioShortId/studio-settings.

const sections = [
  { id: 'profile', label: 'Profile', active: true },
] as const;

export function AccountPage(): JSX.Element {
  return (
    <div className="flex h-full min-h-0 flex-col overflow-hidden md:flex-row">
      <nav
        aria-label="Account settings navigation"
        className={cn(
          'shrink-0 border-border bg-surface',
          'border-b md:w-56 md:border-b-0 md:border-r',
          'md:h-full md:overflow-y-auto',
        )}
      >
        <p className="px-4 pt-5 pb-2 font-mono text-[10px] uppercase tracking-wider text-text-muted">
          Account
        </p>
        <ul className="flex gap-1 overflow-x-auto px-2 pb-3 md:flex-col md:overflow-x-visible md:pb-4">
          {sections.map((s) => (
            <li key={s.id} className="md:w-full">
              <span
                className={cn(
                  'block whitespace-nowrap rounded-sm px-3 py-2 text-sm transition-colors duration-150',
                  'border-l-2',
                  s.active
                    ? 'bg-accent-bg text-accent border-l-accent'
                    : 'border-transparent text-text-muted',
                )}
              >
                {s.label}
              </span>
            </li>
          ))}
        </ul>
      </nav>
      <div className="min-w-0 flex-1 overflow-y-auto p-6">
        <p className="text-sm text-text-muted">
          Personal account settings are coming soon. For now, manage studio
          access from Manage studio in the sidebar.
        </p>
      </div>
    </div>
  );
}
